module.exports = {"Administración de atributos de cliente":"Administración de atributos de cliente","Listado de atributos de cliente":"Listado de atributos de cliente","Tipo":"Tipo","Cliente":"Cliente","Nuevo":"Nuevo","Cancelar":"Cancelar","Ver tipo de atributo de cliente":"Ver atributo de cliente","Editar atributo de cliente":"Editar atributo de cliente","Nuevo atributo de cliente":"Nuevo atributo de cliente"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/atributos-cliente/es.json
// module id = 1062
// module chunks = 0